const rootUrl = process.env.REACT_APP_API

export function queryEmployment() {
  const url = `${rootUrl}/callmodel`
  const params = {
    results_param: 'accessResults',
    model: 'employment',
    req_params: {
      format: 'json',
    },
  }
  return fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
}

export function queryLGAEmployment() {
  const url = `${rootUrl}/callmodel`
  const params = {
    results_param: 'accessResults',
    model: 'employment',
    lga: true,
    req_params: {
      format: 'json',
    },
  }
  return fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
}
